import { ColumnType } from "components/AgGrid/constants";

import { ACTION_COLUMN_NAME } from "constants/aggrid";
import {
  BillingDocumentColId,
  BillingDocumentColumnDef,
  BusinessAddressColumnDef,
  BusinessColId,
  BusinessColumnDef,
  LivestockSalesColumnDef,
  RetainedProceedsColumnDef,
  XeroIntegrationBusinessDef,
} from "constants/columnDefinitions";

import { filterColIdsFromColumnDef, formatters, getters } from "lib/agGrid";

import { BillingDocumentActionRenderer } from "./renderers";

export const MoneyTableColId = {
  SHOW_ON_OUTSTANDING_SETTLEMENT_REPORT: "fbe7d485-58c4-4766-9257-b6937490c6a7",
};

export const InterestSettingsColId = {
  DEBIT_INTEREST_RATE: "c71ebd89-2178-4b7c-8f5a-99a9ba0de935",
  CREDIT_INTEREST_RATE: "b0c1f8d2-3e4a-4f5b-9c6d-7e8f9a0b1c2d",
  DAYS_OVERDUE_THRESHOLD: "32e0a9a9-3ebd-4231-9cbb-322fbc4a71ca",
  CALCULATED_INTEREST: "38d566af-75c5-4061-b474-712b2059f6ef",
};

export const InterestSettingsColumnDef = {
  [InterestSettingsColId.DEBIT_INTEREST_RATE]: {
    colId: InterestSettingsColId.DEBIT_INTEREST_RATE,
    field: "interestSettings.debitInterestRate",
    headerName: "Debit Interest Rate",
    type: ColumnType.PERCENTAGE,
  },
  [InterestSettingsColId.CREDIT_INTEREST_RATE]: {
    colId: InterestSettingsColId.CREDIT_INTEREST_RATE,
    field: "interestSettings.creditInterestRate",
    headerName: "Credit Interest Rate",
    type: ColumnType.PERCENTAGE,
  },
  [InterestSettingsColId.DAYS_OVERDUE_THRESHOLD]: {
    colId: InterestSettingsColId.DAYS_OVERDUE_THRESHOLD,
    field: "interestSettings.daysOverdueThreshold",
    headerName: "Days Overdue Threshold",
    type: ColumnType.NUMERIC,
  },
  [InterestSettingsColId.CALCULATED_INTEREST]: {
    colId: InterestSettingsColId.CALCULATED_INTEREST,
    field: "interestSettings.calculatedInterest",
    headerName: "Suggested Interest ($)",
    width: 75,
    type: ColumnType.CURRENCY,
    valueGetter: getters.dollarsGetter,
    valueFormatter: formatters.dollarsCreditDebitFormatter,
  },
};

export const MoneyColumnDefinitions = showInterestColumns =>
  [
    {
      headerName: "Document",
      children: filterColIdsFromColumnDef(BillingDocumentColumnDef, [
        BillingDocumentColId.ACTIONS,
        BillingDocumentColId.CALCULATED_BILLING_REFERENCE,
        BillingDocumentColId.DOCUMENT_DOWNLOAD,
      ]),
    },
    {
      headerName: "Retained Proceeds",
      children: Object.values(RetainedProceedsColumnDef),
    },
    {
      headerName: "Business",
      children: [
        ...filterColIdsFromColumnDef(BusinessColumnDef, BusinessColId.ACTIONS),
        {
          headerName: "Address",
          children: Object.values(BusinessAddressColumnDef),
        },
        ...Object.values(XeroIntegrationBusinessDef),
      ],
    },
    showInterestColumns && {
      headerName: "Interest Settings",
      children: Object.values(InterestSettingsColumnDef),
    },
    {
      headerName: "Sale(s)",
      children: Object.values(LivestockSalesColumnDef),
    },
    BillingDocumentColumnDef[BillingDocumentColId.CALCULATED_BILLING_REFERENCE],
    {
      colId: MoneyTableColId.SHOW_ON_OUTSTANDING_SETTLEMENT_REPORT,
      field: "showOnOutstandingSettlementReport",
      headerName: "Show On Outstanding Settlement Report",
      type: ColumnType.BOOLEAN,
    },
    {
      colId: BillingDocumentColId.ACTIONS,
      field: "billingDocument.id",
      headerName: ACTION_COLUMN_NAME,
      valueGetter: ({ data }) => {
        if (!data) {
          return null;
        }
        return [
          data.billingDocument.id,
          data.billingDocument.status,
          data.billingDocument.hasFinancialChanges ||
            data.billingDocument.hasCosmeticChanges,
        ].join("-");
      },
      cellRenderer: BillingDocumentActionRenderer,
      pinned: "right",
      width: 150,
    },
  ].filter(Boolean);
